import styles from './logo.module.scss';
import { Link } from 'react-router-dom';
import LogoIcon from '@/assets/icons/voice-logo.svg?react';
import Icon from '@ant-design/icons';

interface LogoProps {
  onLogoClick?: () => void;
}
export default function Logo({ onLogoClick }: LogoProps) {
  return (
    <Link onClick={onLogoClick} to="/" className={styles.logo}>
      <Icon component={() => <LogoIcon data-testid="logo-icon" />} style={{ fontSize: '37px' }} />
      <div className={styles.logoContainer}>
        <p>VOICESPHERE</p>
        <svg className={styles.logoContainerDisc}>
          <circle cx="50%" cy="50%" r={2} fill="currentColor"></circle>
        </svg>
        <p>AI</p>
      </div>
    </Link>
  );
}
